import { render, staticRenderFns } from "./RecuperacaoSenha.vue?vue&type=template&id=63ecba9a&scoped=true"
import script from "./RecuperacaoSenha.vue?vue&type=script&lang=js"
export * from "./RecuperacaoSenha.vue?vue&type=script&lang=js"
import style0 from "./RecuperacaoSenha.vue?vue&type=style&index=0&id=63ecba9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ecba9a",
  null
  
)

export default component.exports